import React from 'react';
import { Icon } from '@iq/react-components';

export const SeverityCell = ({ severity, color }) => {
  return (
    <div className="alarm-serverity-icon-container">
      <Icon
        icon="he-statusrisk"
        size="s"
        color={color || '#666'}
        className="alarm-severity-icon"
      />
      <span
        className="alarm-severity-text"
        style={{ textTransform: 'capitalize' }}
      >
        {severity || '-'}
      </span>
    </div>
  );
};
